import { API } from '../APIs/index';
import { Pagination, Tokens } from '../Interfaces/Interfaces';
import { TokenValidator } from './TokenValidator';

export default class CustomerService {
  tokens: any | Tokens;
  get = API.customer + 'get/';
  post = API.customer + 'post/';
  delete = API.customer + 'delete/';
  put = API.customer + 'put/';

  Areas: any;

  constructor() {
    this.tokens = TokenValidator();
  }

  async getCustomerDetails(id: any) {
    try {
      let response = await fetch(this.get + `getDetails/${id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${this.tokens.access_token}`,
          'x-api-key': `${process.env.REACT_APP_API_KEY}`
        },
      });

      return await response.json();
    } catch (err) {
      throw err;
    }
  }


  async getCustomers(data: Pagination) {
    try {
      let response = await fetch(this.get + `agent/${data.id}/count/${data.page}/${data.pageSize}/?whereCondition=${data.whereCondition}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${this.tokens.access_token}`,
          'x-api-key': `${process.env.REACT_APP_API_KEY}`
        }
      });

      return await response.json();
    } catch (err) {
      throw err;
    }
  }


}
